import { defineSlotRecipe } from '@chakra-ui/react';
import colors from '../colors';

const Tooltip = defineSlotRecipe({
  slots: ['content', 'arrow'],
  base: {
    content: {
      '--tooltip-bg': colors.podcastShade600,
      fontSize: '14px',
      borderRadius: '8px',
      textAlign: 'center',
      py: '5px',
    },
  },
  variants: {
    visual: {
      destructive: {
        content: {
          '--tooltip-bg': colors.podcastRed600,
        },
      },
    },
  },
});

export default Tooltip;
